import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { bool, func, object } from 'prop-types'
import { useEffect } from 'react'

export const AzureBlob = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  newConnection,
  getHelperText,
}) => {
  const requiredFieldsHaveValue =
    !updatedAccount.metadata.blob_accountname || !updatedAccount.metadata.blob_key

  const checkForAzureErrorsHidden = () => {
    newConnection && setRequiredFieldMissing(requiredFieldsHaveValue)
  }

  const checkForAzureErrors = () => {
    newConnection
      ? setRequiredFieldMissing(requiredFieldsHaveValue)
      : setRequiredFieldMissing(!updatedAccount.metadata.blob_accountname)
  }

  useEffect(() => {
    checkForAzureErrors()
    checkForAzureErrorsHidden()
  }, [updatedAccount.metadata])

  return (
    <>
      <div>
        <TextField
          style={{ width: '100%', marginBottom: 12 }}
          variant="outlined"
          required
          label={t`Azure account name`}
          data-testid="azure-account-name"
          value={updatedAccount.metadata.blob_accountname ?? ''}
          onChange={e => {
            setUpdatedAccount({
              ...updatedAccount,
              metadata: {
                ...updatedAccount.metadata,
                blob_accountname: e.target.value,
              },
            })
          }}
          helperText={getHelperText(!updatedAccount.metadata.blob_accountname)}
        />
      </div>
      <div>
        <TextField
          style={{ width: '100%', marginBottom: 12 }}
          variant="outlined"
          required
          type="password"
          label={t`Storage key`}
          data-testid="storage-key"
          value={updatedAccount.metadata.blob_key ?? ''}
          onChange={e => {
            setUpdatedAccount({
              ...updatedAccount,
              metadata: { ...updatedAccount.metadata, blob_key: e.target.value },
            })
          }}
          helperText={getHelperText(newConnection && !updatedAccount.metadata.blob_key)}
        />
        <Typography variant="caption">
          <Trans>
            Keys are securely stored and never surfaced to the user. Entering a new value will
            override the existing key.
          </Trans>
        </Typography>
      </div>
    </>
  )
}

AzureBlob.propTypes = {
  updatedAccount: object.isRequired,
  setUpdatedAccount: func.isRequired,
  newConnection: bool.isRequired,
  setRequiredFieldMissing: func.isRequired,
  getHelperText: func.isRequired,
}
